import React from "react";

import AibleStep from "containers/CreateWizard/AibleStep";

import styles from "./style.module.css";

export default class MarketplaceDescription extends React.PureComponent {
  render() {
    const { updateDescription, description } = this.props;
    return (
      <AibleStep
        message={"Please add a description for your blueprint."}
        secondaryMessage={"This is what users will see before they decide whether they want to buy your blueprint"}
        isBreak
      >
        <div className={styles.descriptionInput}>
          <AreaInput
            placeholder={"Enter Description"}
            onBlur={(val) => updateDescription(val)}
            defaultValue={description}
          />
        </div>
      </AibleStep>
    );
  }
}

class AreaInput extends React.PureComponent {
  render() {
    const { placeholder, onBlur, defaultValue } = this.props;
    return (
      <div className={styles.areaInputWrapper}>
        <textarea placeholder={placeholder} rows={3} onBlur={(event) => onBlur(event.target.value)}>
          {defaultValue}
        </textarea>
      </div>
    );
  }
}
